import {Component, OnInit} from '@angular/core';
import {Account} from 'app/core/auth/account.model';
import {AccountService} from 'app/core/auth/account.service';
import {UserData} from "../../models/user-data";
import * as jsdom from "jsdom";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent extends SubscriptionManager implements OnInit {
  account: Account | null = null;
  isUserRole = true;
  userData!: UserData;

  constructor(private accountService: AccountService, private confService: ConfigurazioneGeneraleService) {
    super();
  }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userData") ?? '{}');
    if (this.userData.email) {
      if (!this.userData.email.includes('@')){
        this.userData.email = "";
      }
    }
    this.subs.sink = this.accountService.identity().subscribe(account => (this.account = account));

  }

  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }

}
